// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__mZpe9","errorLogs":"EditorFooter_errorLogs__lo085"};